/**
 * Layout: Theme
 * -----------------------------------------------------------------------------
 * Entry file for all global theme scripts.
 *
 */
import '@/layout/theme.scss'
import '../old-theme/theme.dev'

/**
 * Core scripts.
 */
import EventBus from '~/core/event-bus'
import Query from '~/core/query'

/**
 * Components.
 */
import BulkOrderProgress from '~/components/bulk-order-progress'
import siteHeader from '~/components/site-header'
import videoElement from '~/components/video-element'
import predictiveSearchResults from '~/components/predictive-search-results'
import cartUpsell from '~/components/cart-upsell'

/**
 * Global Basis functions.
 */
window.basis = window.basis || {}
window.basis.EventBus = EventBus()
window.basis.Query = (query) => Query(query)

document.addEventListener('DOMContentLoaded', () => {
  BulkOrderProgress().init()
  siteHeader().init()
  videoElement().init()
  predictiveSearchResults().init()
  cartUpsell().init()
})
